// lineClusteredColumnComboChart, lineStackedColumnComboChart.

import ReactECharts from "echarts-for-react";
import type { EChartsOption } from "echarts";
import { ChartShell } from "./_chartShell";
import type { VisualProps } from "./types";
import {
  baseChartOption,
  bucketKey,
  bucketKeys,
  firstFieldRef,
  isEmpty,
  makeCategoryClick,
  pbiAxisDefault, // AGENT-C: dotted gridlines + Segoe UI axis labels.
  pickColumn,
} from "./_echartsHelpers";

export function ComboChartVisual({ spec, data, onFilter }: VisualProps) {
  const empty = isEmpty(data);
  const rows = data.rows ?? [];
  const fields = spec.fields ?? {};
  const categoryKey = bucketKey(fields.Category);
  const columnKeys = bucketKeys(fields.Y);
  const lineKeys = bucketKeys(fields.Y2);
  const stacked = spec.type === "lineStackedColumnComboChart";
  const onClick = makeCategoryClick(
    { visualId: spec.id, spec, onFilter },
    firstFieldRef(fields.Category),
  );

  const option: EChartsOption = {
    ...baseChartOption(),
    // AGENT-C: PBI axis defaults applied to both x and the dual y axes.
    xAxis: {
      ...pbiAxisDefault,
      type: "category",
      data: categoryKey ? (pickColumn(rows, categoryKey) as string[]) : [],
    },
    yAxis: [
      { ...pbiAxisDefault, type: "value", position: "left" },
      { ...pbiAxisDefault, type: "value", position: "right" },
    ],
    series: [
      ...columnKeys.map((k) => ({
        type: "bar" as const,
        name: k,
        yAxisIndex: 0,
        stack: stacked ? "col" : undefined,
        data: pickColumn(rows, k) as number[],
      })),
      ...lineKeys.map((k) => ({
        type: "line" as const,
        name: k,
        yAxisIndex: 1,
        smooth: false,
        showSymbol: false,
        data: pickColumn(rows, k) as number[],
      })),
    ],
  };

  return (
    <ChartShell title={spec.title} isEmpty={empty} status={data.status}>
      <ReactECharts
        option={option}
        notMerge
        style={{ height: "100%", width: "100%" }}
        onEvents={{ click: onClick }}
      />
    </ChartShell>
  );
}
